import React, { Component } from 'react';
import './studymaterialcard.css';
import '../DOC/docCard.css';
import SubjectCard from './subjectCard';
import CardsHeader from './cardsHeader';
import CardView from './cardView';
import TileView from './tileView';
import { connect } from 'react-redux';

class StudyMaterialCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subjectData: {},
      subjectId: 0,
      topicId: 0,
      view: 'card',
      subjects: [],
      globalDocuments: [], // ✅ Store per-subject documents here
    };
  }

  componentDidMount() {
    this.setState({ subjects: this.props.subjects });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedtab !== this.props.selectedtab) {
      this.setState({ subjects: [], subjectData: {}, subjectId: 0, globalDocuments: [] });
    } else if (prevProps.selected_course !== this.props.selected_course) {
      this.setState({ subjectData: {}, subjectId: 0, globalDocuments: [] });
    } else if (prevProps.subjects !== this.props.subjects) {
      this.setState({ subjects: this.props.subjects });
    }
  }

  subjectClick = (subjectData) => {
    const generateGlobalDocs = this.props.generateGlobalDocs;
    const globalDocs = generateGlobalDocs([subjectData]); // ✅ Full nested subject data
  
    this.setState({
      subjectData,
      subjectId: subjectData.subjectId,
      globalDocuments: globalDocs,
    });
  };
  
  handleMarkAsComplete = (index) => {
    this.setState((prevState) => {
      const updatedDocs = [...prevState.globalDocuments];
      if (!updatedDocs[index]) return;

      updatedDocs[index].isMarked = true;

      // Recalculate locks for current subject
      let unlockedFound = false;
      for (let i = 0; i < updatedDocs.length; i++) {
        if (!unlockedFound && !updatedDocs[i].isMarked) {
          updatedDocs[i].isLocked = false;
          unlockedFound = true;
        } else if (updatedDocs[i].isMarked) {
          updatedDocs[i].isLocked = false;
        } else {
          updatedDocs[i].isLocked = true;
        }
      }

      return { globalDocuments: updatedDocs };
    });
  };

  render() {
    return (
      <div className="subject-container">
        {this.state.subjects.length > 0 && (
          <SubjectCard
            subjects={this.props.subjects}
            subjectClick={this.subjectClick}
          />
        )}
        <div className="container">
          {this.state.subjectId !== 0 && (
            <div>
              <CardsHeader
                topicId={this.state.topicId}
                view={this.state.view}
                changeView={(view) => this.setState({ view })}
                changeTopic={(topicId) => this.setState({ topicId })}
                subjectData={this.state.subjectData}
              />
              {this.state.view === 'title' ? (
                <CardView
                  topicId={this.state.topicId}
                  subjectData={this.state.subjectData}
                  globalDocuments={this.state.globalDocuments}
                  handleMarkAsComplete={this.handleMarkAsComplete}
                  {...this.props}
                />
              ) : (
                <TileView
                topicId={this.state.topicId}

                  subjectData={this.state.subjectData}
                  globalDocuments={this.state.globalDocuments}
                  handleMarkAsComplete={this.handleMarkAsComplete}
                  {...this.props}
                />
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(StudyMaterialCard);
